// Browser notification utilities for work order overdue alerts
// Uses localStorage to track which work orders have been notified

const NOTIFIED_KEY = "wo_notified_ids";

export const getNotificationPermission = () => {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  const result = await Notification.requestPermission();
  return result;
};

const getNotifiedIds = () => {
  try {
    const raw = localStorage.getItem(NOTIFIED_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const setNotifiedIds = (ids) => {
  try {
    localStorage.setItem(NOTIFIED_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage errors
  }
};

export const sendOverdueNotifications = (workOrders) => {
  if (!("Notification" in window) || Notification.permission !== "granted") {
    return 0;
  }

  const notified = getNotifiedIds();
  let sentCount = 0;
  const now = Date.now();

  workOrders.forEach((wo) => {
    if (!wo.end_datetime || ["Completed", "Cancelled"].includes(wo.status)) return;

    const endDate = new Date(wo.end_datetime).getTime();
    if (endDate >= now) return; // not overdue

    // Skip if we've already notified for this WO recently (within 12 hours)
    const lastNotified = notified[wo.id];
    if (lastNotified && now - lastNotified < 12 * 60 * 60 * 1000) return;

    try {
      new Notification(`Work Order Overdue: ${wo.work_order_number}`, {
        body: `${wo.site_name}\n${wo.description}\nPriority: ${wo.priority}`,
        icon: "/favicon.ico",
        tag: `wo-${wo.id}`,
        requireInteraction: false,
      });
      notified[wo.id] = now;
      sentCount++;
    } catch (e) {
      console.warn("Failed to send notification:", e);
    }
  });

  setNotifiedIds(notified);
  return sentCount;
};

export const clearNotifiedFor = (workOrderId) => {
  const notified = getNotifiedIds();
  delete notified[workOrderId];
  setNotifiedIds(notified);
};
